/* Extracted from BulkSimilarityPage.jsx — see git log for history. */
import React from 'react';
// InboundMergeChip — rendered on TARGET rows that have ≥1 row ultimately
// merging into them. Click filters the page to show only the inbound
// sources + this target row, so admin can review the consolidating cluster.
// Clicking the chip again (when filter is active) clears the filter.
const InboundMergeChip = ({ count, stagingId, isActive, onClick }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onClick?.(isActive ? null : stagingId);
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded border text-[9px] transition-colors cursor-pointer ${isActive
        ? 'bg-emerald-600 text-white border-emerald-600 hover:bg-emerald-700'
        : 'bg-emerald-50 text-emerald-800 border-emerald-300 hover:bg-emerald-100 hover:border-emerald-400'}`}
      title={isActive
        ? 'Click to clear the inbound-merge filter and show all rows again.'
        : `${count} row${count !== 1 ? 's' : ''} ultimately merge into this row. Click to filter the page to just those rows + this target.`}
      data-testid={`inbound-chip-${stagingId}`}
    >
      <span aria-hidden>←</span> {count} {isActive ? 'merging here (filtered)' : `row${count !== 1 ? 's' : ''} merge here`}
    </button>
  );
};

export default InboundMergeChip;
